import { lazy } from '../../shared/deployment';

export const WebinarEvaluation = lazy(() => import('./WebinarEvaluation'));
